<div fxLayout="column" fxHide.lt-md>
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else paymentHistoryListFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="paymentHistoryListFlexColumnTemplate"></ng-container>
    </div>
</div>

<div fxLayout="column" fxHide.gt-sm ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <ng-container *ngTemplateOutlet="paymentHistoryCardViewTemplate"></ng-container>
</div>

<ng-template #paymentHistoryCardViewTemplate>
    <div fxFlex="5%"></div>
    <div fxFlex="90%" *ngIf="!showSpinner">
        <div *ngIf="isBrowserIE; else paymentHistoryCardViewHeaderTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentHistoryCardViewHeaderTemplate"></ng-container>
        </div>
        <div class="display-text normal-paragraph-spacing">
            <mat-card>
                <mat-card-content>
                    <div fxLayout="column">
                        <div fxLayout="column" fxLayoutGap="16px">
                            <div fxLayout="column">
                                <div *ngIf="isBrowserIE; else paymentHistoryCardViewPageHeaderFlexColumnTemplate"
                                    [ngClass]="{ 'ie-display': isBrowserIE }">
                                    <ng-container
                                        *ngTemplateOutlet="paymentHistoryCardViewPageHeaderFlexColumnTemplate"></ng-container>
                                </div>
                            </div>
                            <!-- Filter Control -->
                            <mat-form-field *ngIf="openNotesPaymentHistoryList.length > 5" appearance="fill"
                                style="width: 100%;">
                                <mat-label>Filter by Note Status</mat-label>
                                <mat-select [(ngModel)]="selectedNoteStatus" (selectionChange)="filterNotes()">
                                    <mat-option *ngFor="let status of uniqueNoteStatuses" [value]="status">
                                        {{ status }}
                                    </mat-option>
                                    <mat-option [value]="''">All</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <ng-container *ngFor="let row of filteredNotesList">
                                <mat-card *ngIf="row.noteId">
                                    <mat-card-content>
                                        <div style="width: 100%;">
                                            <!-- Left Section: Note ID and Note Status -->
                                            <div>
                                                <mat-card-title>{{ row.noteId }}{{row.conversionnote}}
                                                    <a class="tooltip-link" (click)="openToolTip('noteId')"
                                                        style="display: inline-flex; align-items: center; vertical-align: middle;">
                                                    </a>
                                                </mat-card-title>
                                                <mat-card-subtitle>{{ row.noteStatus }}
                                                    <a class="tooltip-link" (click)="openToolTip('noteStatus')"
                                                        style="display: inline-flex; align-items: center; vertical-align: middle;">
                                                        <mat-icon class="tooltip-icon-link"
                                                            style="font-size: 16px; vertical-align: middle; margin-left: 4px;"
                                                            matTooltip="{{ getToolTip('noteStatus') }}"
                                                            matTooltipPosition="after"
                                                            matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                                                    </a>
                                                </mat-card-subtitle>
                                                <div style="display: flex; justify-content: space-between;">
                                                    <mat-label><span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@payment-history-list.table.column-header.next-payment-due-date">payment-history-list.table.column-header.next-payment-due-date</span></mat-label>
                                                    <span style="text-align: right;">{{ row.nextPaymentDueDate }}</span>
                                                </div>
                                                <div *ngIf="row.pastDueAmount > 0"
                                                    style="display: flex; justify-content: space-between;">
                                                    <mat-label><span class="header-superscript header-after-content-2"
                                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@payment-history-list.table.column-header.past-due-amount">payment-history-list.table.column-header.past-due-amount</span></mat-label>
                                                    <span style="text-align: right;">{{ row.pastDueAmount | currency
                                                        }}</span>
                                                </div>
                                                <div *ngIf="row.lateFeeDue > 0"
                                                    style="display: flex; justify-content: space-between;">
                                                    <mat-label> <span class="header-superscript header-after-content-1"
                                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@payment-history-list.table.column-header.late-fee-due">payment-history-list.table.column-header.late-fee-due</span></mat-label>
                                                    <span style="text-align: right;">{{ row.lateFeeDue | currency
                                                        }}</span>
                                                </div>
                                                <div style="display: flex; justify-content: space-between;">
                                                    <mat-label><span class="header-superscript"
                                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@payment-note-list.table.column-header.auto-pay-flag">payment-note-list.table.column-header.auto-pay-flag</span></mat-label>
                                                    <span style="text-align: right;">{{
                                                        row.autoPayFlag
                                                        }}</span>
                                                </div>
                                                <div style="display: flex; justify-content: space-between;">
                                                    <mat-label> <span class="header-superscript header-after-content-3"
                                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@payment-history-list.table.column-header.total-amount-due">payment-history-list.table.column-header.total-amount-due</span></mat-label>
                                                    <span style="text-align: right;">{{ row.totalAmountDue | currency
                                                        }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                    <mat-card-actions
                                        style="display: flex; justify-content: right; align-items: right; border-top: 1px solid #e0e0e0; padding-top: 8px;">
                                        <button mat-flat-button color="primary" (click)="selectNote(row.noteId)"
                                            i18n-matTooltip="@@esign-details.table.column-header.options"
                                            matTooltip="esign-details.table.column-header.options"
                                            i18n="@@esign-details.table.column-header.options">
                                            esign-details.table.column-header.options
                                        </button>
                                    </mat-card-actions>
                                </mat-card>
                            </ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div fxLayout="column" style="margin-top: 16px" *ngIf="openNotesPaymentHistoryListFound">
            <div *ngIf="isBrowserIE; else paymentHistoryListNoticesFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="paymentHistoryListNoticesFlexColumnTemplate"></ng-container>
            </div>
        </div>
        <div fxLayout="column" style="margin-top: 16px" *ngIf="openNotesPaymentHistoryListFound">
            <div *ngIf="isBrowserIE; else paymentHistoryNoticesFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="paymentHistoryNoticesFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
    <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #paymentHistoryCardViewPageHeaderFlexColumnTemplate>
    <div fxFlex="5%"></div>
    <div fxLayout="column" fxFlex="90%">
        <div class="display-text primary-dark-color-important"> <!--  *ngIf="userFullName.length > 0" -->
            <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
                <b><span i18n="@@page-header.payments.payment-history">page-header.payments.payment-history</span></b>
            </span>
        </div>
        <div fxFlex="100%" class="border-bottom-blue" style="margin-top: 16px"></div>
    </div>
</ng-template>

<ng-template #paymentHistoryListFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
        </div>
        <div fxLayout="column" *ngIf="!showSpinner">
            <div *ngIf="isBrowserIE; else paymentHistoryListTableFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="paymentHistoryListTableFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #paymentHistoryListTableFlexColumnTemplate>
    <div fxFlex="100%" class="display-text primary-dark-color-important" style="margin-top: 12px" *ngIf="displayTitle">
        <b><span i18n="@@payment-history-list.table.title">payment-history-list.table.title</span></b>
    </div>
    <div fxFlex="100%" class="display-text primary-dark-color-important" style="margin-top: 12px" *ngIf="displayTitle">
        <b><span i18n="@@payment-history-list.table.pending-payments">payment-history-list.table.payments</span>&nbsp;
            {{pendingPayment.pendingPaymentAmt | currency}}</b>
    </div>

    <div fxFlex="100%" class="display-text title-spacer" *ngIf="!openNotesPaymentHistoryListFound">
        <i><span i18n="@@payment-history-list.table.no-records">payment-history-list.table.no-records</span></i>
    </div>

    <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }" style="margin-top: 12px"
        *ngIf="openNotesPaymentHistoryListFound">
        <mat-table #table [dataSource]="tableDataSource" ngClass.lt-md="small-table-text">
            <!-- noteId Column -->
            <ng-container matColumnDef="noteId">
                <mat-header-cell *matHeaderCellDef fxFlex="12%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-history-list.table.column-header.note-id">payment-history-list.table.column-header.note-id
                    </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    <button mat-button color="primary" (click)="selectNote(row.noteId)">
                        <b>{{row.noteId}}{{row.conversionnote}}</b>
                    </button>
                </mat-cell>
            </ng-container>
            <!-- noteStatus Column -->
            <ng-container matColumnDef="noteStatus">
                <mat-header-cell *matHeaderCellDef fxFlex="16%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-history-list.table.column-header.note-status">payment-history-list.table.column-header.note-status</span>
                    <a class="tooltip-link" (click)="openToolTip('noteStatus')">
                        <mat-icon class="tooltip-icon-link" matTooltip="{{ getToolTip('noteStatus') }}"
                            matTooltipPosition="after" matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                    </a>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="16%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.noteStatus
                    }}</mat-cell>
            </ng-container>
            <!-- nextPaymentDueDate Column -->
            <ng-container matColumnDef="nextPaymentDueDate">
                <mat-header-cell *matHeaderCellDef fxFlex="12%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-history-list.table.column-header.next-payment-due-date">payment-history-list.table.column-header.next-payment-due-date</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.nextPaymentDueDate
                    }}</mat-cell>
            </ng-container>
            <!-- pastDueAmount Column -->
            <ng-container matColumnDef="pastDueAmount">
                <mat-header-cell *matHeaderCellDef fxFlex="12%">
                    <span class="header-superscript header-after-content-2"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-history-list.table.column-header.past-due-amount">payment-history-list.table.column-header.past-due-amount</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.pastDueAmount | currency
                    }}</mat-cell>
            </ng-container>
            <!-- lateFeeDue Column -->
            <ng-container matColumnDef="lateFeeDue">
                <mat-header-cell *matHeaderCellDef fxFlex="12%">
                    <span class="header-superscript header-after-content-1"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-history-list.table.column-header.late-fee-due">payment-history-list.table.column-header.late-fee-due</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.lateFeeDue | currency
                    }}</mat-cell>
            </ng-container>
            <!-- totalAmountDue Column -->
            <ng-container matColumnDef="totalAmountDue">
                <mat-header-cell *matHeaderCellDef fxFlex="12%">
                    <span class="header-superscript header-after-content-3"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-history-list.table.column-header.total-amount-due">payment-history-list.table.column-header.total-amount-due</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.totalAmountDue | currency
                    }}</mat-cell>
            </ng-container>
            <!-- payoffAmount Column -->
            <ng-container matColumnDef="payoffAmount">
                <mat-header-cell *matHeaderCellDef fxFlex="12%">
                    <span class="header-superscript header-after-content-4"
                        [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-history-list.table.column-header.payoff-amount">payment-history-list.table.column-header.payoff-amount</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.payoffAmount | currency
                    }}</mat-cell>
            </ng-container>
            <!-- autoPayFlag Column -->
            <ng-container matColumnDef="autoPayFlag">
                <mat-header-cell *matHeaderCellDef fxFlex="12%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@payment-history-list.table.column-header.auto-pay-flag">payment-history-list.table.column-header.auto-pay-flag</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="12%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
                    row.autoPayFlag
                    }}</mat-cell>
            </ng-container>
            <mat-header-row class="primary-light-bg-top-to-bottom-gradient" *matHeaderRowDef="tableDisplayedColumns"
                ngClass.lt-md="small-header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"
                [ngClass]="{ 'primary-lightest-bg': row.noteId === selectedNoteId }"></mat-row>
        </mat-table>
    </div>
    <div fxFlex="100%" fxLayoutAlign="end center" class="small-display-text primary-light-color"
        *ngIf="openNotesPaymentHistoryListFound">
        <app-table-record-count [recordCount]="openNotesPaymentHistoryList.length"
            i18n-singularLabel="@@payment-history-list.table.record-count.singular-label"
            singularLabel="payment-history-list.table.record-count.singular-label"
            i18n-multipleLabel="@@payment-history-list.table.record-count.multiple-label"
            multipleLabel="payment-history-list.table.record-count.multiple-label"></app-table-record-count>
    </div>
    <div fxLayout="column" style="margin-top: 16px" *ngIf="openNotesPaymentHistoryListFound">
        <div *ngIf="isBrowserIE; else paymentHistoryListNoticesFlexColumnTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentHistoryListNoticesFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxLayout="column" style="margin-top: 16px" *ngIf="openNotesPaymentHistoryListFound">
        <div *ngIf="isBrowserIE; else paymentHistoryNoticesFlexColumnTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentHistoryNoticesFlexColumnTemplate"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #paymentHistoryListNoticesFlexColumnTemplate>
    <div fxFlex="100%" class="display-text">
        <sup>1</sup>&nbsp;<span i18n="@@payment-history-list.notices.1">payment-history-list.notices.1</span>
    </div>
    <div fxFlex="100%" class="display-text">
        <sup>2</sup>&nbsp;<span i18n="@@payment-history-list.notices.2">payment-history-list.notices.2</span>
    </div>
    <div fxFlex="100%" class="display-text">
        <sup>3</sup>&nbsp;<span i18n="@@payment-history-list.notices.3">payment-history-list.notices.3</span>
    </div>
    <div fxFlex="100%" class="display-text">
        <sup>4</sup>&nbsp;<span i18n="@@payment-history-list.notices.4a">payment-history-list.notices.4a</span>&nbsp;<b>
            <span i18n="@@payment-history-list.notices.4b">payment-history-list.notices.4b</span></b>&nbsp;
        <span i18n="@@payment-history-list.notices.4c">payment-history-list.notices.4c</span>
    </div>
</ng-template>

<ng-template #paymentHistoryNoticesFlexColumnTemplate>
    <ng-container *ngIf="show">
        <div fxFlex="100%" class="display-text">
            <sup>*</sup>&nbsp;<b><span i18n="@@payment-history.notices.1">payment-history.notices.1</span></b>
        </div>
    </ng-container>
</ng-template>

<ng-template #paymentHistoryCardViewHeaderTemplate>
    <div class="display-text primary-dark-color-important normal-paragraph-spacing">
        <b><span
                i18n="@@payment-history-list.table.pending-payments">payment-history-list.table.pending-payments</span>&nbsp;
            {{ pendingPayment.pendingPaymentAmt | currency }}</b>
    </div>
</ng-template>
